import React from "react";
import ReactMarkdown from "react-markdown";
import * as remarkGfm from "remark-gfm";

const remarkGfmPlugin = (
  (remarkGfm as unknown as { default?: unknown }).default ?? remarkGfm
) as () => void;

interface LdsMarkdownProps {
  children: string;
  className?: string;
}

export function LdsMarkdown({ children, className = "" }: LdsMarkdownProps) {
  return (
    <div className={`space-y-3 break-words text-sm leading-6 [&_a]:font-semibold [&_a]:text-indigo-700 [&_a]:underline [&_a]:underline-offset-2 dark:[&_a]:text-indigo-300 [&_blockquote]:border-l-4 [&_blockquote]:border-slate-300 [&_blockquote]:pl-3 [&_code]:rounded [&_code]:bg-slate-100 [&_code]:px-1 [&_code]:py-0.5 dark:[&_code]:bg-slate-800 [&_h1]:text-xl [&_h1]:font-semibold [&_h2]:text-lg [&_h2]:font-semibold [&_h3]:font-semibold [&_li]:ml-5 [&_ol]:list-decimal [&_pre]:overflow-x-auto [&_pre]:rounded-xl [&_pre]:bg-slate-950 [&_pre]:p-3 [&_pre]:text-slate-100 [&_table]:block [&_table]:overflow-x-auto [&_ul]:list-disc ${className}`}>
      <ReactMarkdown
        remarkPlugins={[remarkGfmPlugin]}
        skipHtml
        components={{
          a: ({ children: linkChildren, ...props }) => (
            <a {...props} target="_blank" rel="noreferrer">
              {linkChildren}
            </a>
          ),
        }}
      >
        {children}
      </ReactMarkdown>
    </div>
  );
}
